<template>
  <b-container class="py-5">
    <b-row>
      <b-col cols="9">
        <h4 class="mb-3">Su orden</h4>
        <b-table
          :fields="table.headers"
          show-empty
          empty-text="Aun no agregas artículos a tu carrito"
          :items="items">
          <template v-slot:cell(quantity)="row">
            <b-col sm="5" class="pl-0">
              <b-input min="1" type="number" v-model="row.item.quantity" />
            </b-col>
          </template>
          <template v-slot:cell(amount)="row">
            {{ row.item.quantity * row.item.price | toCurrency}}
          </template>
          <template v-slot:cell(price)="row">
            {{ row.item.price | toCurrency}}
          </template>
          <template v-slot:cell(actions)="row">
            <b-button size="sm" @click="onRemoveItem(row.item)" variant="outline-secondary">
              <font-awesome-icon :icon="['fas', 'trash']" />
            </b-button>
          </template>
        </b-table>
        <h4 class="mb-3">Información de envio</h4>
        <b-form id="payment-form" @submit="onSubmit">
          <b-form-row>
            <b-col sm="6">
              <b-form-group
                id="input-group-name"
                label="Nombres"
                label-for="input-name">
                <b-form-input
                  id="input-name"
                  v-model="form.data.firstname"
                  type="text"
                  required
                  placeholder="Nombres"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <b-form-group
                id="input-group-lastname"
                label="Apellidos"
                label-for="input-lastname">
                <b-form-input
                  id="input-lastname"
                  v-model="form.data.lastname"
                  type="text"
                  required
                  placeholder="Apellidos"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-form-row>
          <b-form-row>
            <b-col sm="6">
              <b-form-group
                id="input-group-email"
                label="Email"
                label-for="input-email">
                <b-form-input
                  id="input-email"
                  v-model="form.data.email"
                  type="email"
                  required
                  placeholder="Email"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <b-form-group
                id="input-group-phone"
                label="Teléfono"
                label-for="input-phone">
                <b-form-input
                  id="input-phone"
                  v-model="form.data.phone"
                  type="text"
                  required
                  placeholder="Teléfono"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-form-row>
          <b-form-row>
            <b-col sm="6">
              <b-form-group
                id="input-group-street"
                label="Calle"
                label-for="input-street">
                <b-form-input
                  id="input-street"
                  v-model="form.data.street"
                  type="text"
                  required
                  placeholder="Calle"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="3">
              <b-form-group
                id="input-group-external-number"
                label="Número exterior"
                label-for="input-external-number">
                <b-form-input
                  id="input-external-number"
                  v-model="form.data.externalNumber"
                  type="text"
                  required
                  placeholder="Número exterior"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="3">
              <b-form-group
                id="input-group-internal-number"
                label="Número interior"
                label-for="input-external-number">
                <b-form-input
                  id="input-internal-number"
                  v-model="form.data.internalNumber"
                  type="text"
                  placeholder="Número interior"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-form-row>
          <b-form-row>
            <b-col sm="6">
              <b-form-group
                id="input-group-city"
                label="Ciudad/Población"
                label-for="input-city">
                <b-form-input
                  id="input-city"
                  v-model="form.data.city"
                  type="text"
                  required
                  placeholder="Ciudad o población"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="3">
              <b-form-group
                id="input-group-state"
                label="Estado"
                label-for="input-state">
                <b-form-input
                  id="input-city"
                  v-model="form.data.state"
                  type="text"
                  required
                  placeholder="Estado"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="3">
              <b-form-group
                id="input-group-zipcode"
                label="Código postal"
                label-for="input-zipcode">
                <b-form-input
                  id="input-zipcode"
                  v-model="form.data.zipcode"
                  type="number"
                  @change="onChangeZipcode"
                  required
                  placeholder="Código postal"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-form-row>
          <b-form-row>
            <b-col sm="6">
              <b-form-group
                id="input-group-shipping-method"
                label="Método de envio"
                label-for="input-shipping-method">
                <b-form-select
                  id="input-shipping-method"
                  v-model="form.data.shipping"
                  :options="form.metadata.shippingMethods"
                  value-field="CourierServiceId"
                  text-field="CourierServiceDescription"
                  @change="onChangeShippingMethod"
                  required
                  placeholder="Elija un método de envio"
                ></b-form-select>
              </b-form-group>
            </b-col>
          </b-form-row>
          <b-form-row>
            <b-col>
              <h4 class="mb-3">Información de pago</h4>
            </b-col>
          </b-form-row>
          <b-form-row>
            <b-form-group label="Método de pago">
            <b-form-radio-group
              id="radio-group-paymenth-method"
              v-model="form.data.paymenthMethod"
              :options="form.metadata.paymenthMethods"
              required
              name="paymenth-method" />
          </b-form-group>
          </b-form-row>
          <b-form-row v-show="form.data.paymenthMethod === 'card'">
            <b-col sm="6">
              <b-form-group
                id="input-group-card-holder"
                label="Nombre"
                label-for="input-card-holder"
                description="Como aparece en su tarjeta">
                <b-form-input
                  id="input-card-holder"
                  data-checkout="cardholderName"
                  type="text"
                  required
                  placeholder="Nombre"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <b-form-group
                id="input-group-card-number"
                label="Número de tarjeta"
                label-for="input-card-number">
                <b-form-input
                  id="input-card-number"
                  data-checkout="cardNumber"
                  onselectstart="return false"
                  onCut="return false"
                  onDrag="return false"
                  onDrop="return false"
                  autocomplete=off
                  @update="onChangeCard"
                  type="number"
                  required
                  placeholder="Número de tarjeta" />
                <input type="hidden" name="payment_method_id" id="payment_method_id" />
              </b-form-group>
            </b-col>
          </b-form-row>
          <b-form-row v-show="form.data.paymenthMethod === 'card'">
            <b-col sm="2">
              <b-form-group
                id="input-group-expiration-month"
                label="Mes exp."
                label-for="input-expiration-month">
                <b-form-select
                  id="input-expiration-month"
                  data-checkout="cardExpirationMonth"
                  onselectstart="return false"
                  onCut="return false"
                  onDrag="return false"
                  onDrop="return false"
                  autocomplete=off
                  type="text"
                  required
                  :options="form.metadata.months" />
              </b-form-group>
            </b-col>
            <b-col sm="2">
              <b-form-group
                id="input-group-expiration-year"
                label="Año exp."
                label-for="input-expiration-year">
                <b-form-select
                  id="input-expiration-year"
                  data-checkout="cardExpirationYear"
                  onselectstart="return false"
                  onCut="return false"
                  onDrag="return false"
                  onDrop="return false"
                  autocomplete=off
                  type="text"
                  :options="form.metadata.years"
                  required />
              </b-form-group>
            </b-col>
            <b-col sm="2">
              <b-form-group
                id="input-group-cvv"
                label="CVV"
                label-for="input-cvv">
                <b-form-input
                  id="input-cvv"
                  data-checkout="securityCode"
                  onselectstart="return false"
                  onCut="return false"
                  onDrag="return false"
                  onDrop="return false"
                  autocomplete=off
                  type="number"
                  required
                  placeholder="CVV" />
              </b-form-group>
            </b-col>
          </b-form-row>
          <b-form-row v-show="form.data.paymenthMethod === 'transfer'">
            <b-col>
              <b-card-group deck class="mb-3">
                <b-card no-body>
                  <b-card-body>
                    <b-card-title>Transferencia bancaría</b-card-title>
                    <b-card-sub-title class="text-muted">
                      Deberá realizar una transferencia bancaría a la siguiente cuenta.
                    </b-card-sub-title>
                    <b-card-text>
                      <div><b>Banco:</b> BBVA</div>
                      <div><b>Beneficiario:</b> Pamela Molina Salas</div>
                      <div><b>Cuenta:</b> 1597255172</div>
                      <div><b>Clabe:</b> 012180015972551726</div>
                      <div><b>Total:</b> {{ total | toCurrency }}</div>
                    </b-card-text>
                  </b-card-body>
                </b-card>
                <b-card no-body>
                  <b-card-body>
                    <b-card-title>CoDi desde la app de su banco</b-card-title>
                    <b-card-sub-title class="text-muted">
                      Deberá escanear el código QR desde la sección CoDi de su app bancaria.
                    </b-card-sub-title>
                    <b-card-text>
                      <b-img :src="qrImage" />
                    </b-card-text>
                  </b-card-body>
                </b-card>
              </b-card-group>
            </b-col>
          </b-form-row>
          <b-form-row v-show="form.data.paymenthMethod === 'paypal'">
            <b-col>
              <b-card no-body class="mb-3">
                  <b-card-body>
                    <b-card-title>Pago seguro con Paypal</b-card-title>
                    <b-card-text>
                      Al dar click en <b>pagar</b> será redirigido al sitio web de Paypal
                    </b-card-text>
                  </b-card-body>
                </b-card>
            </b-col>
          </b-form-row>
          <b-button type="submit" block variant="purple">Pagar</b-button>
        </b-form>
      </b-col>
      <b-col cols="3">
        <h4 class="mb-3">Resumen</h4>
        <b-card no-body>
          <b-list-group flush>
            <b-list-group-item class="d-flex justify-content-between lh-condensed">
              <div>
                <h6 class="my-0">Su orden</h6>
                <small class="text-muted">Todos los productos</small>
              </div>
              <span class="text-muted">{{ subtotal | toCurrency }}</span>
            </b-list-group-item>
            <b-list-group-item class="d-flex justify-content-between lh-condensed">
              <div>
                <h6 class="my-0">Envio</h6>
                <small class="text-muted">{{ shippingMethod.CourierName }}: {{ shippingMethod.DeliveryDays }}</small>
              </div>
              <span class="text-muted">{{ shippingMethod.TotalPrice | toCurrency }}</span>
            </b-list-group-item>
            <b-list-group-item class="d-flex justify-content-between lh-condensed">
              <div class="text-success">
                <h6 class="my-0">Cupón</h6>
                <small>Descuento por cupón</small>
              </div>
              <span class="text-success">{{ form.data.coupon.value | toCurrency }}</span>
            </b-list-group-item>
            <b-list-group-item class="d-flex justify-content-between lh-condensed">
              <div>
                <h6 class="my-0">Total</h6>
                <small class="text-muted">Pesos mexicanos</small>
              </div>
              <span class="text-dark">{{ total | toCurrency }} MXN</span>
            </b-list-group-item>
          </b-list-group>
        </b-card>
        <b-card no-body class="mt-3 p-0">
          <b-card-body class="p-2 text-purple">
             <b-input-group id="input-group-coupon" label="Cupon" label-for="input-coupon">
              <template v-slot:append>
              <b-button @click="onCheckCoupon" variant="purple">Redimir</b-button>
              </template>
              <b-form-input
                id="input-coupon"
                v-model="couponCode"
                type="text"
                placeholder="Cupón"></b-form-input>
            </b-input-group>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-overlay :show="overlay" rounded="sm" fixed no-wrap />
  </b-container>
</template>

<script>
export default {
  name: 'Checkout',
  computed: {
    items () {
      return this.$store.state.cart.items
    },
    subtotal () {
      return this.items.reduce((acc, item) => {
        acc += (item.quantity * item.price)
        return acc
      }, 0)
    },
    total () {
      return this.subtotal + this.shippingMethod.TotalPrice - this.form.data.coupon.value
    }
  },
  data () {
    return {
      qrImage: require('@/assets/images/qr-example.png'),
      overlay: false,
      couponCode: '',
      shippingMethod: { CourierName: '', TotalPrice: 0 },
      table: {
        headers: [
          { key: 'quantity', label: 'Cantidad', class: 'w-25' },
          { key: 'name', label: 'Nombre' },
          { key: 'price', label: 'P. Unit.' },
          { key: 'amount', label: 'Importe' },
          { key: 'actions', label: 'Acc.' }
        ]
      },
      form: {
        metadata: {
          shippingMethods: [],
          paymenthMethods: [
            { value: 'card', text: 'Tarjeta de crédito/débito' }
            // { value: 'transfer', text: 'Transferencia bancaria/CoDi' },
            // { value: 'paypal', text: 'Paypal' }
          ],
          months: [
            { value: '01', text: '01 - Enero' },
            { value: '02', text: '02 - Febrero' },
            { value: '03', text: '03 - Marzo' },
            { value: '04', text: '04 - Abril' },
            { value: '05', text: '05 - Mayo' },
            { value: '06', text: '06 - Junio' },
            { value: '07', text: '07 - Julio' },
            { value: '08', text: '08 - Agosto' },
            { value: '09', text: '09 - Septiembre' },
            { value: '10', text: '10 - Octubre' },
            { value: '11', text: '11 - Noviembre' },
            { value: '12', text: '12 - Diciembre' }
          ],
          years: [
            { value: '21', text: '2021' },
            { value: '22', text: '2022' },
            { value: '23', text: '2023' },
            { value: '24', text: '2024' },
            { value: '25', text: '2025' },
            { value: '26', text: '2026' },
            { value: '27', text: '2027' },
            { value: '28', text: '2028' },
            { value: '29', text: '2029' },
            { value: '30', text: '2030' }
          ]
        },
        data: {
          items: [],
          paymenthMethod: 'card',
          coupon: { code: '', value: 0 },
          shipping: '',
          client: {},
          address: {}
        }
      }
    }
  },
  methods: {
    async onSubmit (evt) {
      evt.preventDefault()
      this.form.data.items = this.$store.state.cart.items.map(item => ({ _id: item._id, quantity: item.quantity }))

      if (this.form.data.paymenthMethod === 'card') {
        this.onCreditCardPayment()
      }
    },
    async onChangeZipcode (zipcode) {
      this.form.data.shipping = null
      const items = this.$store.state.cart.items.map(item => ({ _id: item._id, quantity: item.quantity }))
      this.overlay = true
      try {
        const { data } = await this.$http.post('/shippings', { items, zipcode })
        this.form.metadata.shippingMethods = data.docs.map(row => {
          row.CourierServiceDescription = `${row.CourierName}: ${row.DeliveryDays} $ ${row.TotalPrice}`
          return row
        })
      } catch (error) {
        const { response } = error
        response.data.errors.forEach(function (er) {
          this.$bvToast.toast(er.message, {
            title: 'Error obteniendo costos de envio',
            variant: 'danger',
            solid: true
          })
        }.bind(this))
      } finally {
        this.overlay = false
      }
    },
    onCheckCoupon () {
      console.log('Cupon :::>', this.couponCode)
    },
    onChangeShippingMethod (value) {
      this.shippingMethod = this.form.metadata.shippingMethods.find(s => s.CourierServiceId === value) || {}
    },
    async onRemoveItem (item) {
      const confirm = await this.$bvModal.msgBoxConfirm(`¿Remover el artículo ${item.name}?`,
        { title: 'Confirme la acción', okTitle: 'Remover', cancelTitle: 'Cancelar' })
      if (confirm) this.$store.commit('removeFromCart', item)
    },
    onCreditCardPayment () {
      this.overlay = true
      const form = document.querySelector('#payment-form')
      window.Mercadopago.createToken(form, async function (status, response) {
        if (status !== 200 && status !== 201) {
          this.$bvToast.toast('No se pudo procesar el pago, por favor recargue la página y verifique sus datos bancarios', {
            title: 'Error procesando su pago',
            solid: true
          })
          this.overlay = false
        } else {
          this.form.data.payment = response
          const { data } = await this.$http.post('/checkout', this.form.data)
          this.overlay = false
          console.log('DATA =========>', data)
          // this.$router.push(`/orders/${data._id}?orderNumber=${data.orderNumber}`)
          // console.log('Nueva orden', order)
        }
      }.bind(this))
    },
    onOfflinePayment () {
      console.log('Offline')
    },
    onPaypalPayment () {
      console.log('Paypal')
    },
    async onChangeCard (card) {
      if (card.length >= 6) {
        const bin = card.substring(0, 6)
        window.Mercadopago.getPaymentMethod({ bin }, function (status, response) {
          console.log('response =========>', response)
          document.getElementById('payment_method_id').value = response[0].id
        })
      }
    }
  }
}
</script>
